import { Blood, Eart, Eye, Heart, Teeth, Time } from '../../../Assets/SVGS'
import Header from '../../common/Header/Header'
import { useTranslation } from 'react-i18next'
import './Six.css'
import SixCard from './SixCard/SixCard'
function Six(){
  const { t } = useTranslation();
  return(
    <div className="six-container container">
      <Header header={t('improveYourHealth')} desc={t('browseServices')}/>
      <div className="six-content content">
        <SixCard header={t('generalTreatment')} desc={t('generalTreatmentDesc')} icon={<Time width="40px"/>}/>
        <SixCard header={t('teethWhitening')} desc={t('teethWhiteningDesc')} icon={<Teeth width="40px"/>}/>
        <SixCard header={t('heartSurgery')} desc={t('heartSurgeryDesc')} icon={<Heart width="40px"/>}/>
        <SixCard header={t('earTreatment')} desc={t('earTreatmentDesc')} icon={<Eart width="40px"/>}/>
        <SixCard header={t('visionProblems')} desc={t('visionProblemsDesc')} icon={<Eye width="40px"/>}/>
        <SixCard header={t('bloodTransfusion')} desc={t('bloodTransfusionDesc')} icon={<Blood width="40px"/>}/> 
      </div>
    </div>
  )
}
export default Six